import {PagePuffWrapper} from "../../Blocks/PagePuff/components";
import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";

export const Video = styled.video`
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    display: inline-block;
    z-index: 1;
    object-fit: cover;
    height: 100%;
    width: 100%;
    ${media.lessThan(breakpoints.mobile)`
		height: ${({height}) => (height ? height : "auto")};
		min-height: ${({height}) => (height ? height : "450px")};
		position: relative;
	`}
`;

export const VideoWrapper = styled.div`
    display: flex;
    width: 100%;
    height: ${({height}) => (height ? height : "100%")};
    align-items: center;
    justify-content: center;
    position: relative;
    ${media.lessThan(breakpoints.mobile)`
		flex-direction: column;
		height: ${({videoHeight}) => (videoHeight ? videoHeight : "auto")};
	`}
`;
export const VideoIframe = styled.iframe`
    width: 100%;
    position: absolute;
    height: 100%;
    z-index: 2;
    border-radius: ${({theme}) => theme.border.radius};
`;

export const VideoControl = styled.video`
    width: 100%;
    position: absolute;
    height: 100%;
    z-index: 2;
    border-radius: ${({theme}) => theme.border.radius};
`;
export const VideoButton = styled.button.attrs(({
                                                  ariaLabel, position
                                                }) => ({
  "aria-label": ariaLabel || "play video",
}))`
    position: absolute;
    width: 48px;
    height: 48px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    display: flex;
    border: none;
    cursor: pointer;
    z-index: 2;
  
    ${({position}) =>
            position === 'center' ?
            css`
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            `:  css`
                        bottom: 20px;
                        right: 132px;

                        ${media.lessThan(breakpoints.ipadPlus)`
                        bottom: 16px;
                        right: 16px;
                      `}
                    `}
    &:hover {
        i {
            transition: 0.2s ease;
            color: ${({theme}) => theme.colors.primary};
        }
    }

    i {
        transition: 0.2s ease;
        font-size: 24px;
        color: black;

        &::before {
            padding: 0;
        }
    }
`;

export const Thumbnail = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: ${({theme}) => theme.border.radius};

    height: 100%;
    align-items: center;
    justify-content: center;
    background-image: ${({bgImage}) =>
            bgImage
                    ? `url(${bgImage})`
                    : `url("/media/0oih55qs/frosunda1.png?anchor=center&mode=crop&rnd=132507344321470000")`};

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    ${PagePuffWrapper} & {
        &:before {
            content: "";
            width: 100%;
            padding-bottom: 56.25%;

            overflow: hidden;
        }
    }
`;
